<template>
  <AccountIconWh40 :image-url="imageUrl" />
</template>

<script>
import profile from '../../../../images/styleguide/IMG_1809.png'
import AccountIconWh40 from '../../components/atoms/account_icons/AccountIconWh40.vue'
export default {
  components: { AccountIconWh40 },
  data() {
    return {
      imageUrl: ''
    }
  },
  mounted() {
    this.imageUrl = profile
  }
}
</script>
